import React, { ReactElement } from 'react';
import { IconButton } from 'src/common/icon-button';
import { Integration } from 'src/common/interfaces/integration.interface';

import { CheckmarkStrongIcon, DotMenuStrongIcon } from 'src/monet/icons';
import { IntegrationDisconnectParams, IntegrationKeyType } from '../list-factory';
import {
  DashboardIntegrationsConnectionCardOptions,
  DashboardIntegrationsConnectionCardOptionsProps,
} from './card-options';

interface DashboardIntegrationsConnectionCardProps<T>
  extends Pick<DashboardIntegrationsConnectionCardOptionsProps, 'onMenuItemClick'> {
  provider: Integration;
  keys: T[];
  type: 'api-key' | 'oauth';
  onDisconnect: (params: IntegrationDisconnectParams<T>) => void;
  icon: ReactElement;
  menuItem?: ReactElement;
  renderContent: (key: T) => ReactElement;
}

export const DashboardIntegrationsConnectionCard = <T,>({
  keys,
  provider,
  icon,
  type,
  renderContent,
  onMenuItemClick,
  onDisconnect,
  menuItem,
}: DashboardIntegrationsConnectionCardProps<T>) => {
  const onDisconnectClicked = (key: T) => () => {
    onDisconnect({ name: provider.name, stack: key, type });
  };

  return (
    <div className='flex flex-col space-y-2 text-bedrock-black'>
      <h3 className='text-bedrock-p-strong'>Connections</h3>
      <div className='flex flex-col items-start'>
        {keys.map((key, index) => (
          <div
            key={`connection-card-${index}`}
            className='flex flex-shrink-0 items-center space-x-2 p-2 even:bg-bedrock-light-gray odd:bg-bedrock-white rounded-l-lg rounded-r-lg'
          >
            <div className='flex flex-shrink-0'>{icon}</div>
            <div className='flex items-center justify-between'>
              <div className='w-[371px]'>{renderContent(key)}</div>
              <div className='flex items-center'>
                <div className='flex flex-shrink-0 space-x-1'>
                  <CheckmarkStrongIcon />
                  <span className='text-bedrock-p-strong'>{provider.apiKeyConnectedLabel || 'Connected'}</span>
                </div>
                <DashboardIntegrationsConnectionCardOptions
                  onDisconnectClick={onDisconnectClicked(key)}
                  menuItem={menuItem}
                  onMenuItemClick={onMenuItemClick}
                  renderMenuOrigin={(onClick) => (
                    <IconButton onClick={onClick}>
                      <DotMenuStrongIcon />
                    </IconButton>
                  )}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
